export const MATE_CONFIG = {
  // Maximum number of mates a user can have
  MAX_MATES: 10,

  INVITE_EXPIRE_DAYS: 7,

  // Text constants
  MAX_MATES_TEXT: "up to 10 friends",

  // Heartbeat throttle time in milliseconds (15 minutes)
  HEARTBEAT_THROTTLE_MS: 15 * 60 * 1000,

  // Query stale time in milliseconds (15 seconds)
  QUERY_STALE_TIME: 15 * 1000,

  MATE_DESCRIPTION: "Workout mates can see each other's recent workouts.",
} as const;

export type MateConfig = typeof MATE_CONFIG;
